var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1500,
    height: 1000,
    viewBox: "0 0 1500 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_716)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_59_716",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1500,
    height: 1000
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1500 0H0V1000H1500V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_59_716)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1208.6 -52.0002L919.9 -132.9C919.9 -132.9 1069 471.5 505.1 813.1C505.1 813.1 1199.1 834 1208.6 -52.0002Z",
    fill: "url(#paint0_linear_59_716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1577.9 -17.2002L1207.6 -166.7C1207.6 -166.7 1305.2 750 529.7 795.3C529.7 795.3 1352.6 875.5 1577.9 -17.2002Z",
    fill: "url(#paint1_linear_59_716)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M676.7 843.8C970.5 752.1 1225.1 561.9 1225.1 561.9C465 910.6 507.2 203.2 75 0H3.29999V0.1V506.7C24.1 545.8 155 748.3 676.7 843.8Z",
    fill: "url(#paint2_linear_59_716)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1000V500C0 500 179.9 938.2 1500 890.2V1000H0Z",
    fill: "url(#paint3_linear_59_716)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M0 750C0 750 1055.8 1041.6 1500 433.4V1000H0V750Z",
    fill: "url(#paint4_linear_59_716)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1500 716.7C1500 716.7 786.2 1178.1 0.299988 773.2V1000H1500V716.7Z",
    fill: "url(#paint5_linear_59_716)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M0 704.9V998.7L0.3 1000H1500V17.8999C1359.3 726 787.1 942 0 704.9Z",
    fill: "url(#paint6_linear_59_716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M871.6 791.7C871.6 1037 672.8 1235.7 427.6 1235.7C182.4 1235.7 -16.4 1037 -16.4 791.7C-16.4 546.5 182.4 347.7 427.6 347.7C672.8 347.7 871.6 546.5 871.6 791.7Z",
    fill: "url(#paint7_radial_59_716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M208 461.9C208 707.1 9.2 905.9 -236 905.9C-481.2 905.9 -680 707.1 -680 461.9C-680 216.7 -481.2 17.8999 -236 17.8999C9.2 17.8999 208 216.7 208 461.9Z",
    fill: "url(#paint8_radial_59_716)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M936.2 0C936.2 0 1192.5 842.2 0.299988 773.2V1000C181.7 1006.3 365.8 995.7 545.6 971.7C698.8 951.3 858.2 927.7 997.2 856.1C1166.5 768.9 1239.5 603.3 1267.5 420.9C1288.4 284.8 1284.6 132.4 1242.2 0L936.2 0Z",
    fill: "url(#paint9_linear_59_716)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1703.8 35.1998L1210.2 -166.7C1210.2 -166.7 1307.8 750 532.2 795.3C532.2 795.3 1478.5 927.9 1703.8 35.1998Z",
    fill: "url(#paint10_linear_59_716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M-174.1 108.1C-174.1 108.1 385.1 1080.3 1715.2 828.2L1460.6 -243.7L-174.1 108.1Z",
    fill: "url(#paint11_linear_59_716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M459.2 917.2C459.2 917.2 1148.4 726.5 1160.1 -125.1L217.7 -78.3001L459.2 917.2Z",
    fill: "url(#paint12_linear_59_716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M2070 95.3999C2070 400.2 1822.9 647.3 1518 647.3C1213.1 647.3 966 400.2 966 95.3999C966 -209.5 1213.1 -456.6 1518 -456.6C1822.9 -456.6 2070 -209.5 2070 95.3999Z",
    fill: "url(#paint13_radial_59_716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M2084 831.8C2084 1154.3 1822.5 1415.8 1500 1415.8C1177.5 1415.8 916 1154.3 916 831.8C916 509.2 1177.5 247.8 1500 247.8C1822.5 247.8 2084 509.2 2084 831.8Z",
    fill: "url(#paint14_radial_59_716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1562 731.4C1562 976.6 1363.2 1175.4 1118 1175.4C872.8 1175.4 674 976.6 674 731.4C674 486.2 872.8 287.4 1118 287.4C1363.2 287.4 1562 486.2 1562 731.4Z",
    fill: "url(#paint15_radial_59_716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.7,
    d: "M1699.7 167.6C1781.1 263.6 1693.2 472 1503.4 633.2C1313.5 794.3 1093.5 847.1 1012 751.1C930.6 655.1 1018.4 446.6 1208.3 285.5C1398.2 124.4 1618.2 71.5998 1699.7 167.6Z",
    fill: "url(#paint16_radial_59_716)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M321.9 1040.2L321.4 1038.8C775.3 883.1 983.9 593.2 1079 377.5C1182 143.7 1177.6 -55.8 1177.6 -57.8H1179.1C1179.1 -55.8 1183.5 144 1080.3 378.1C1019.7 515.5 934.5 637.8 826.9 741.4C692.4 870.8 522.5 971.4 321.9 1040.2Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M680.1 780.9C662.7 780.9 645.1 780.5 627.2 779.7C510.1 774.2 402 749.9 306 707.6C229.2 673.7 159.8 628.3 99.9 572.5C-2.19999 477.5 -42 384.1 -42.4 383.2L-41 382.6C-40.7 383.6 -0.899994 476.6 100.9 571.4C194.9 658.9 362.5 765.8 627.3 778.2C910.3 791.4 1123.4 696 1252.3 613.7C1417.7 508 1513.1 382.8 1544.5 307.6L1545.9 308.2C1514.4 383.6 1418.8 509.1 1253.1 614.9C1132.2 692.2 937.2 780.9 680.1 780.9Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.4 997C50.1 997 -14.3 993.6 -80.8 986.9L-80.7 985.4C318.7 1025.7 643.4 944.7 884.2 744.4C1074.5 586.2 1175.4 381.4 1226.5 237.4C1281.9 81.3998 1292.3 -38.7001 1292.4 -39.9001L1293.9 -39.7001C1293.8 -38.5001 1283.4 81.6998 1227.9 237.9C1195.4 329.6 1153.9 415.6 1104.7 493.4C1043.2 590.7 969.3 675.6 885.2 745.6C684.1 912.7 424.8 997 112.4 997Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_716",
    x1: 1209.79,
    y1: -752.077,
    x2: 2429.54,
    y2: 1914.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#D4D4D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_716",
    x1: 1377.36,
    y1: -238.416,
    x2: 2116.01,
    y2: 204.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#D4D4D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_716",
    x1: 1208.7,
    y1: 458.416,
    x2: 523.231,
    y2: 1329.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#EFEFEF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#A7A7A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_59_716",
    x1: 629.348,
    y1: 876.577,
    x2: 672.157,
    y2: 444.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#D4D4D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_59_716",
    x1: 642.998,
    y1: 1022.15,
    x2: 642.998,
    y2: 203.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_59_716",
    x1: 178.567,
    y1: 573.987,
    x2: 2093.92,
    y2: 1030.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#D4D4D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_59_716",
    x1: 471.616,
    y1: 1077.39,
    x2: 253.024,
    y2: 685.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_59_716",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(427.624 791.744) scale(444 444)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#EFEFEF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_59_716",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-236.035 461.878) scale(444)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#EFEFEF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_59_716",
    x1: 1550.78,
    y1: 224.632,
    x2: 470.166,
    y2: 1844.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_59_716",
    x1: 1647.79,
    y1: -5.32617,
    x2: 2328.85,
    y2: 845.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#D4D4D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_59_716",
    x1: 173.524,
    y1: 792.131,
    x2: 28.2864,
    y2: 1446.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_59_716",
    x1: 1239.86,
    y1: -138.505,
    x2: 1854.14,
    y2: 188.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_59_716",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1518 95.3509) scale(551.995 551.995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#EFEFEF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_59_716",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1500 831.75) scale(584)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#EFEFEF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_59_716",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1118 731.378) scale(444)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#EFEFEF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_59_716",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1355.84 459.339) rotate(-40.3183) scale(450.922 450.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#EFEFEF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1500,
    height: 1000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBackground);
export default __webpack_public_path__ + "static/media/auth_background.33e90392db84795e807a0431585599d5.svg";
export { ForwardRef as ReactComponent };